<style media="screen" type="text/css">
.agent-list-box {
  height: 180px;
  /*max-height: 180px;*/
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>

<template>
  <div>
    <v-dialog v-model="dialog.flag" class="br-25" persistent width="520">
      <v-card>
        <!--  close btn -->
        <p class="text-right pr-3" style="margin-bottom:-10px !important">
          <v-icon color="#8F8F8F" small @click="dialog.flag=false">
            mdi-window-close
          </v-icon>
        </p>
        <v-card-text class="flex-column ">
          <!--  dialog title -->
          <p class="page-title text-center"> {{ $lang.ASSIGN.toUpperCase() }} {{ agent_type.toUpperCase() }}</p>

          <div class="mt-4">
            <v-row>
              <v-col class="pt-0" md="12">
                <p class="sub-title-text-dark mb-2">{{ $lang.SELECT }} {{ agent_type }}</p>

                <v-text-field
                    v-model="search_query"
                    :label="$lang.SEARCH"
                    append-icon="mdi-magnify"
                    dense
                    outlined
                    rounded
                    single-line
                    @keyup="getPickupAgents"
                ></v-text-field>

                <div class="agent-list-box px-0  ">
                  <v-checkbox
                      v-for="pickup_agent in pickup_agent_list"
                      :key="pickup_agent.id"
                      v-model="pickup_agent_id_list"
                      :label="pickup_agent.pickup_agent_name"
                      :value="pickup_agent.id"
                      class="ml-2 mt-0 custome-checkbox"
                      @change="singleSelect(pickup_agent)">
                    <template v-slot:label>
                      <div>
                        <p class="sub-title-text-dark">
                          <v-badge
                              :content="(pickup_agent.today_count).toString()"
                              bordered
                              color="primary"
                              overlap
                          >
												<span class="pr-3">
													{{ pickup_agent.agent_name }}
												</span>

                          </v-badge>
                        </p>
                        <p class="select-secondary-text">{{ pickup_agent.agent_phone_number }}</p>
                      </div>
                    </template>
                  </v-checkbox>
                </div>

              </v-col>

            </v-row>
          </div>
          <div class="text-center mt-4">
            <v-btn :loading="dialog.btn_loading" class="fw-bold ml-5" color="primary"
                   @click="reAssign(pickup_agent_id_list[0])">
              {{ $lang.ASSIGN }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ['dialog', 'shipment', 'shipment_id_list', 'agent_type', "reAssign"],
  data() {
    return {
      search_query: "",
      pickup_agent: "",
      pickup_agent_list: [],
      pickup_agent_id_list: [],

    }
  },
  created() {
    this.getPickupAgents()
  },
  methods: {
    /* get  agent list */
    getPickupAgents() {
      const self = this
      self.filter_agent_type = status
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.search_query,
        filter_agent_type: JSON.stringify([self.agent_type]),
        is_active: true
      };

      self.table_loading = true;
      const successHandler = (response) => {
        self.pickup_agent_list = response.data.agent_list

      };
      const finallyHandler = () => {
        self.table_loading = false
      };
      self.request_GET(self, self.$urls.AGENT_LIST, params, successHandler, null, null, finallyHandler)
    },
    singleSelect(pickup_agent) {
      this.pickup_agent = pickup_agent
      this.pickup_agent_id_list = []
      this.pickup_agent_id_list.push(pickup_agent.id)
    },

  }
}

</script>